<template>
  <div>
    <SysBtn class="ml-3" :size="size" @click="dialog_ativo = ! dialog_ativo">
      <v-icon left>mdi-chart-timeline-variant</v-icon>
      Movimentação estoque
    </SysBtn>

    <SysDialogFullscreen v-model="dialog_ativo">
      <template #titulo.text>
        <div class="d-flex align-center">
          <span class="font-20">Análise Macro</span>
          <span class="font-14 pt-1 pl-1"
                style="color: #fcfcfc">- Indicador de Movimentação do Estoque (R$ custo)</span>
        </div>
      </template>

      <div class="px-1">
        <TabelaMovimentacaoEstoque v-if="dialog_ativo" :filtros_iniciais="filtros_iniciais" :indicador_evolucao="indicador_evolucao" />
      </div>
    </SysDialogFullscreen>
  </div>
</template>

<script>
import SysDialogFullscreen from "@/components/padraoDeLayout/SysDialogFullScreen";
import TabelaMovimentacaoEstoque from "@/components/Diagnostico/SlowNoMoving/MovimentacaoEstoque/Tabela/Index";

export default {
  name: "MovimentacaoEstoque",
  components: {
    SysDialogFullscreen,
    TabelaMovimentacaoEstoque,
  },
  props: {
    size: Number,
    indicador_evolucao: {
      type: Boolean,
      required: false
    },
    filtros_iniciais: {
      type: Object,
      required: false
    },
  },
  data: () => ({
    dialog_ativo: false,
  })
}
</script>

<style scoped>

</style>
